import { useCallback, useEffect } from 'react';
import { useActiveElement } from '@/hooks/useActiveElement';
interface Options<T> {
  targetKeys: ReadonlyArray<T>;
  callback: (key: ReadonlyArray<T>[number]) => void;
  targetRef?: null | HTMLElement;
  preventDefaut?: boolean;
}
export function useKeys<T extends string>(options: Options<T>) {
  const { targetKeys, callback, targetRef, preventDefaut } = options;
  const activeElement = useActiveElement();
  const upHandler = useCallback(
    (event: KeyboardEvent) => {
      if (targetRef !== activeElement) {
        return; // nooop
      }
      if (targetKeys.includes(event.key as T)) {
        if (preventDefaut) {
          event.preventDefault();
        }
        callback(event.key as T);
      }
    },
    [targetKeys, targetRef, callback, preventDefaut, activeElement]
  );

  useEffect(() => {
    window.addEventListener('keydown', upHandler);
    return () => {
      window.removeEventListener('keydown', upHandler);
    };
  }, [upHandler, targetRef]);
}
